import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { MemberContext } from '../context';

const getVal = require('lodash/get');

/**
 * returns DLS select component
 * @param {*} props
 */
const Select = (props) => {
  const {
    fetchUrl,
    fieldLabel,
    fieldId,
    fieldOptions = [],
    fieldValidation,
    cssProperties,
    selectKey,
    selectShowKey,
    onElementChange = [],
    handleOnChangeEvents,
    showProductInfo,
    fieldDefaultOptionLabel = 'Choose One',
    showValueAsCardNumber = false,
    selectValue,
    filledFormData,
    comments,
  } = props;
  const [options, setOptions] = useState([]);
  const memberContextVal = useContext(MemberContext);
  const customInvalidMsg = fieldValidation && fieldValidation.customInvalidMsg
    ? fieldValidation.customInvalidMsg : 'Please select an item in the list';
  const [value, setValue] = useState('');
  const [fieldIdValue, setFieldIdValue] = useState('');
  useEffect(() => {
    if (fetchUrl) {
      setOptions(memberContextVal);
    } else {
      setOptions(fieldOptions);
    }
  }, []);

  useEffect(() => {
    setFieldIdValue(fieldId);
  }, [fieldId]);

  useEffect(() => {
    if (fieldId !== fieldIdValue) setValue('');
    if (filledFormData && filledFormData[fieldId]) {
      setValue(filledFormData[fieldId]);
    }
  }, [fieldId]);

  const handleSelect = (e) => {
    handleOnChangeEvents(onElementChange, e);
    setValue(e.target.value);
  };

  return (
    <div className={cssProperties.style} data-toggle="select">
      <label htmlFor={fieldId} className={fieldLabel.cssProperties.style}>
        {fieldLabel.label}<span>  </span>
        {!fieldValidation.required && <span>{' '}(Optional)</span>}
      </label>
      {fieldLabel
        && fieldLabel.subLabel
        && (
          <div>
            <label htmlFor={fieldId} className={fieldLabel.cssProperties.subLabelStyle}>
              {fieldLabel.subLabel}
            </label>
          </div>
        )}
      <div className="select fluid form-control">
        <select
          name={fieldId}
          id={fieldId}
          aria-label="navigate to"
          //  onChange={(e) => handleOnChangeEvents(onElementChange, e)}
          // onClick={styleSelectedOption}
          value={value}
          onChange={handleSelect}
          required={fieldValidation.required}
          title={customInvalidMsg}
          onInvalid={(e) => e.target.setCustomValidity(`${customInvalidMsg}`)}
          onInput={(e) => e.target.setCustomValidity('')}
        >
          {
            !selectKey && !selectShowKey && Array.isArray(options) ? options.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))
              : (
                /* eslint-disable max-len -- need */
                <>
                  <option value="" selected={true}>{fieldDefaultOptionLabel}</option>
                  {
                    !showProductInfo
                      && options && options.length > 0 ? options.map((optionObj) => (
                        <option
                          key={optionObj[selectKey].accountKey}
                          value={optionObj[selectKey].accountKey}
                        >
                          {optionObj[selectKey][selectShowKey]}
                        </option>
                      ))
                      /* eslint-disable unicorn/no-nested-ternary -- required T */
                      : !showValueAsCardNumber
                        && options
                        && options.length > 0 ? options.map((optionObj) => (
                          <option
                            key={
                              selectValue ? optionObj[selectValue] : optionObj[selectKey].accountKey ? optionObj[selectKey].accountKey : optionObj.accountToken
                            }
                            value={
                              selectValue ? optionObj[selectValue] : optionObj[selectKey].accountKey ? optionObj[selectKey].accountKey : optionObj.accountToken
                            }
                          // disabled={optionObj[selectKey][selectShowKey] === selectedOption}
                          >
                            {getVal(optionObj, 'product.digitalInfo.productDesc') ? optionObj.product.digitalInfo.productDesc : ''} (-{optionObj[selectKey][selectShowKey].split('-')[2]})
                          </option>
                        ))
                        : options && options.length > 0 && options.map((optionObj) => (
                          <option
                            key={optionObj[selectKey][selectShowKey]}
                            value={optionObj[selectKey][selectShowKey]}
                          >
                            {getVal(optionObj, 'product.digitalInfo.productDesc') ? optionObj.product.digitalInfo.productDesc : ''} (-{optionObj[selectKey][selectShowKey].split('-')[2]})
                          </option>
                        ))
                    /* eslint-enable unicorn/no-nested-ternary -- required T */
                  }
                </>
                /* eslint-enable max-len -- need */
              )
          }
        </select>
      </div>
      {
        comments && comments[fieldId]
        && (
          <div id="alert-error" className="alert dls-color-warning pad-1-t">
            <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
            <span>{comments[fieldId].comment}</span>
          </div>
        )
      }
    </div>
  );
};

Select.propTypes = {
  fetchUrl: PropTypes.string,
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  fieldId: PropTypes.string,
  fieldOptions: PropTypes.arrayOf(PropTypes.shape),
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  selectKey: PropTypes.string,
  selectShowKey: PropTypes.string,
  onElementChange: PropTypes.arrayOf(PropTypes.shape),
  handleOnChangeEvents: PropTypes.func,
  showProductInfo: PropTypes.bool,
  fieldDefaultOptionLabel: PropTypes.string,
  showValueAsCardNumber: PropTypes.bool,
  selectValue: PropTypes.string,
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  comments: PropTypes.objectOf(PropTypes.shape),
};

export default Select;
